import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { setFormData } from '../../../utils/network-utils';
import { errorHandl } from '../../../utils/network-utils';

@Injectable({
  providedIn: 'root'
})
export class FleetService {

  public KEY_TOKEN: 'token';

  constructor(private http: HttpClient) { }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  getFleetList(payload): Observable<any> {
    const params = new HttpParams({fromObject: payload});

    return this.http.get<any>(urls.BASE_URL + urls.FLEET_LIST_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getFleetDataById(fleetId): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.ADD_FLEET_URL + '/' + fleetId)
      .pipe(
        catchError(errorHandl)
      );
  }

  getSingleFleetQR(fleetId): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.SINGLE_FLEET_QR_URL + fleetId)
      .pipe(
        catchError(errorHandl)
      );
  }

  getAllFleetQR(data): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.ALL_FLEET_QR_URL, data)
      .pipe(
        catchError(errorHandl)
      );
  }


  addFleet(fleetData, fleetId): Observable<any> {

    if (fleetId) {
      return this.http.put<any>(urls.BASE_URL + urls.ADD_FLEET_URL + '/' + fleetId, fleetData)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.ADD_FLEET_URL, fleetData)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getLateReasons(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_LATE_ONSCENE_REASONS)
      .pipe(
        catchError(errorHandl)
      );
  }

  getLateReasonById(id:any): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_LATE_ONSCENE_REASONS + "/" + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveLateReasons(payload, id): Observable<any> {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.GET_LATE_ONSCENE_REASONS + '/' + id, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.GET_LATE_ONSCENE_REASONS, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }
}
